export const API_ENDPOINTS: { [key: string]: string } = {
  login: "/login",
  logout: "/logout",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  profile: "/profile",
  updatePassword: "/update-password",
  contractList: "/contract-list",
  contractFields: "/form/contract",
  autoApproveContracts: "/contracts/auto-approve",
  getContractById: "/contract",
  saveContract: "/contract",
  deleteContract: "/contract",
  bankList: "/bank-list",
  bankFieldsWorker: "/form/bank/worker",
  bankFieldsCompany: "/form/bank/company",
  users: "/users",
  roles: "/roles",
  permissions: "/permissions",
  whistleblowingList: "/whistleblowing",
  whistleblowingFields: "/form/whistleblowing",
  getWhistleblowingById: "/whistleblowing",
  saveWhistleblowing: "/whistleblowing",
  deleteWhistleblowing: "/whistleblowing",
  controversyList: "/controversy-list",
  controversyFields: "/form/controversy",
  getControversyById: "/controversy",
  saveControversy: "/controversy",
  deleteControversy: "/controversy",
  opportunitiesList: "/opportunities-list",
  deleteOpportunity: "/opportunity",
  getOpportunityById: "/opportunity",
  saveOpportunity: "/opportunity",
  goldOpportunitiesList: "/gold-opportunities-list",
  deleteGoldOpportunity: "/gold-opportunity",
  opportunityFields: "/website/employer/opportunity/menu-list",
  opportunityFormFields: "/form/opportunity",
  goldOpportunityFields: "/form/gold-opportunity",
  getGoldOpportunityById: "/gold-opportunity",
  saveGoldOpportunity: "/gold-opportunity",
  employeesList: "/employees-list",
  employeesFields: "/form/employees",
  deleteEmployee: "/employees",
  saveEmployee: "/employees",
  getEmployee: "/employees",
  employeeFormFields: "/form/employees",
  customerCompanyList: "/customer-company-list",
  customerCompanyFilters: "/filters/customer-company",
  customerCompanyFields: "/website/dynamic-form/get-form/employer/create",
  customerCompanyEditFields: "/website/dynamic-form/get-form/employer/edit",
  deleteCompany: "/customer-company",
  saveCompany: "/customer-company",
  getCompany: "/customer-company",
  collaboratorsList: "/collaborators",
  collaboratorsFields: "/form/collaborators",
  inviteCollaborator: "/invite-collaborator",
  deleteCollaborator: "/collaborators",
  getCollaboratorById: "/collaborators",
  saveCollaborator: "/collaborators",
  alertList: "/alerts-list",
  alertFields: "/form/alerts",
  getAlertById: "/alerts",
  saveAlert: "/alerts",
  deleteAlert: "/alerts",
  chatList: "/chats-list",
  chatFields: "/form/chats",
  sendChatMessage: "/chats/idChat/messages",
  getChatMessages: "/chats/idChat/messages",
  opportunities: "/opportunities",
  autoApproveOpportunities: "/opportunities/auto-approve",
  autoApproveControversies: "/controversy/auto-approve",
  profileFields: "/form/profile",
  getProfile: "/profile",
  saveProfileInfo: "/profile",
  changePwd: "/change-password",
  userFields: "/form/profile",
  createUser: "/users",
  webList: "/web-list",
  webFields: "/form/web",
  getWebById: "/web",
  saveWeb: "/web",
};
